import { render, staticRenderFns } from "./prem_tree_table.vue?vue&type=template&id=9e207344&scoped=true&"
import script from "./prem_tree_table.vue?vue&type=script&lang=js&"
export * from "./prem_tree_table.vue?vue&type=script&lang=js&"
import style0 from "./prem_tree_table.vue?vue&type=style&index=0&id=9e207344&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e207344",
  null
  
)

export default component.exports